import { render } from "./BoardMiddle.vue?vue&type=template&id=23b0ff45&scoped=true"
import script from "./BoardMiddle.vue?vue&type=script&lang=js"
export * from "./BoardMiddle.vue?vue&type=script&lang=js"

import "./BoardMiddle.vue?vue&type=style&index=0&id=23b0ff45&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b0ff45"]])

export default __exports__